// extracted by mini-css-extract-plugin
module.exports = {"season-tag":"_qt6gz9JenOGfTN2BVS3"};